
const templates = import.meta.glob("/client/templates/*.tsx", {eager: true});

export const getTemplate = async ({template_name}) => {
    const templatePath = "/client/templates/" + template_name + ".tsx";
    const templateModule = templates[templatePath];

    if (templateModule == null) {
        throw new Error(
            "reactivated: no template found at " + templatePath +
            " — every Template class needs a matching .tsx file exporting {Template}",
        );
    }
    return templateModule.Template;
};
